/* Routes for the ai-credits area (Area B: billing and AI credits). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [{ path: 'ai-credits/*', lazy: page(() => import('./pages/AiCreditsPage')) }],
}
